import { memo } from 'react'
import { Theme } from '@mui/material/styles'
import ProgressiveDisclosed from 'components/ProgressiveDisclosed'
import { Typography } from '@mui/material'
import { useFormState } from 'react-final-form'
import { progressiveDisclosureValidator, VALIDATOR_EMAIL } from 'validation'
import useEmotionStyles from 'hooks/useEmotionStyles'

const styles = (theme: Theme) => ({
  legal: {
    width: '100%',
    marginTop: theme.spacing(2)
  }
})

type NoteProps = {
  legalText: string
}

const Note = ({ legalText }: React.PropsWithChildren<NoteProps>) => {
  const { values } = useFormState()
  const primaryDebtorData = values.debtors.primary
  const { legal } = useEmotionStyles(styles)

  return (
    <ProgressiveDisclosed
      value={primaryDebtorData?.contact?.email}
      validator={progressiveDisclosureValidator(VALIDATOR_EMAIL)}
      disableDisclose
    >
      <Typography className={legal} variant="caption">
        {legalText}
      </Typography>
    </ProgressiveDisclosed>
  )
}

export default memo(Note)
